import React from 'react';

/** Icone a linea sottile (stile "outline"), disegnate inline: nessun font o file esterno. */
export type IconName =
  | 'planner'
  | 'bell'
  | 'mic'
  | 'sun'
  | 'moon'
  | 'building'
  | 'user'
  | 'users'
  | 'chat'
  | 'whatsapp'
  | 'list'
  | 'note'
  | 'gear'
  | 'database'
  | 'link'
  | 'wallet'
  | 'folder'
  | 'chevronRight'
  | 'chevronDown'
  | 'chevronUp'
  | 'chevronLeft'
  | 'check'
  | 'checkCircle'
  | 'circle'
  | 'plus'
  | 'enter'
  | 'dots'
  | 'play'
  | 'phone'
  | 'stop'
  | 'clock'
  | 'wifi'
  | 'wifiOff'
  | 'logout'
  | 'copy'
  | 'search'
  | 'trash'
  | 'key'
  | 'refresh'
  | 'download'
  | 'inbox'
  | 'layers'
  | 'x'
  | 'euro'
  | 'calendar'
  | 'edit'
  | 'shield'
  | 'server'
  | 'percent'
  | 'star'
  | 'fingerprint'
  | 'face'
  | 'lock'
  | 'eye'
  | 'eyeOff'
  | 'mail'
  | 'send'
  | 'reply'
  | 'forward'
  | 'paperclip'
  | 'maximize'
  | 'restore'
  | 'fullscreen';

const PATHS: Record<IconName, React.ReactNode> = {
  whatsapp: (
    <>
      <path d="M4.2 19.8l1.1-3.9A8.2 8.2 0 1 1 8.4 18.8z" />
      <path d="M9.3 8.4c.3-.4.6-.4.9-.4h.4c.2 0 .4.1.5.4l.6 1.4c.1.2 0 .5-.1.7l-.5.6c.6 1.1 1.4 1.9 2.5 2.5l.6-.5c.2-.1.5-.2.7-.1l1.4.6c.3.1.4.3.4.5v.4c0 .3-.1.6-.4.9-.6.5-1.7.6-3.2-.2-1.6-.9-2.8-2.2-3.6-3.7-.6-1.3-.5-2.4-.2-3z" />
    </>
  ),
  planner: (
    <>
      <rect x="3.5" y="4.5" width="17" height="16" rx="3.5" />
      <path d="M3.5 9.5h17M8 3v3M16 3v3M8 13.5h4M8 16.5h8" />
    </>
  ),
  sun: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4" />
    </>
  ),
  moon: <path d="M19.5 14.6A7.5 7.5 0 0 1 9.4 4.5a7.5 7.5 0 1 0 10.1 10.1Z" />,
  bell: (
    <>
      <path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5H4.5L6 16.5Z" />
      <path d="M10 20a2 2 0 0 0 4 0" />
    </>
  ),
  building: (
    <>
      <path d="M4 20.5h16M5.5 20.5V5a1.5 1.5 0 0 1 1.5-1.5h6A1.5 1.5 0 0 1 14.5 5v15.5M14.5 9.5h3A1.5 1.5 0 0 1 19 11v9.5" />
      <path d="M8.5 7.5h3M8.5 10.5h3M8.5 13.5h3M9 20.5v-3.5h2v3.5" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M4.5 20.5c.6-3.7 3.5-5.8 7.5-5.8s6.9 2.1 7.5 5.8" />
    </>
  ),
  users: (
    <>
      <circle cx="9" cy="8.5" r="3.2" />
      <path d="M2.8 20c.5-3.3 3-5.2 6.2-5.2s5.7 1.9 6.2 5.2" />
      <path d="M15.5 5.6a3.1 3.1 0 0 1 0 5.8M17.4 14.6c2.3.6 3.6 2.3 3.9 5.4" />
    </>
  ),
  chat: (
    <>
      <path d="M12 3.8c-4.7 0-8.3 3.1-8.3 7.2 0 1.7.6 3.2 1.7 4.5L4.5 20l4.3-1.4c1 .3 2.1.5 3.2.5 4.7 0 8.3-3.1 8.3-7.2S16.7 3.8 12 3.8Z" />
      <path d="m9.2 11.2 1.9 1.9 3.8-3.9" />
    </>
  ),
  list: (
    <>
      <path d="m3.5 6.5 1.5 1.5 2.5-3M3.5 12.5 5 14l2.5-3M3.5 18.5 5 20l2.5-3" />
      <path d="M10.5 6.5h10M10.5 12.5h10M10.5 18.5h10" />
    </>
  ),
  note: (
    <>
      <path d="M5 4.5h14A1.5 1.5 0 0 1 20.5 6v9l-5.5 5.5H5A1.5 1.5 0 0 1 3.5 19V6A1.5 1.5 0 0 1 5 4.5Z" />
      <path d="M15 20.5V15h5.5" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3.5v2M12 18.5v2M3.5 12h2M18.5 12h2M6 6l1.4 1.4M16.6 16.6 18 18M6 18l1.4-1.4M16.6 7.4 18 6" />
      <circle cx="12" cy="12" r="6.5" />
    </>
  ),
  database: (
    <>
      <ellipse cx="12" cy="6" rx="7.5" ry="2.8" />
      <path d="M4.5 6v12c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8V6" />
      <path d="M4.5 12c0 1.5 3.4 2.8 7.5 2.8s7.5-1.3 7.5-2.8" />
    </>
  ),
  wallet: (
    <>
      <path d="M4.5 7.5A2.5 2.5 0 0 1 7 5h10.5a1.5 1.5 0 0 1 1.5 1.5V9M4.5 7.5v9A2.5 2.5 0 0 0 7 19h11a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 18 8H5" />
      <circle cx="15.5" cy="13.5" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  folder: <path d="M3.5 7.5A2 2 0 0 1 5.5 5.5h4l2 2.5h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-9Z" />,
  link: <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />,
  chevronRight: <path d="m9 6 6 6-6 6" />,
  chevronDown: <path d="m6 9 6 6 6-6" />,
  chevronUp: <path d="m6 15 6-6 6 6" />,
  chevronLeft: <path d="m15 6-6 6 6 6" />,
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  checkCircle: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.5 12.2 2.3 2.3 4.7-4.8" />
    </>
  ),
  circle: <circle cx="12" cy="12" r="8.5" />,
  plus: <path d="M12 5v14M5 12h14" />,
  enter: <path d="M19 5v6a3 3 0 0 1-3 3H6M9 10l-4 4 4 4" />,
  dots: (
    <>
      <circle cx="9" cy="6" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15" cy="6" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="9" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="9" cy="18" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="15" cy="18" r="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  play: <path d="M7.5 5.5v13l10-6.5-10-6.5Z" />,
  phone: (
    <path d="M6.6 3.8 9 3.5l1.8 4.2-2 1.6c1 2.4 2.6 4 5 5l1.6-2 4.2 1.8-.3 2.4c-.2 1.5-1.5 2.6-3 2.4C9.6 18.2 5.8 14.4 5 7.7c-.2-1.5.9-2.8 2.4-3l-.8-.9Z" />
  ),
  mic: (
    <>
      <rect x="9" y="3.5" width="6" height="11" rx="3" />
      <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v2.5" />
    </>
  ),
  stop: <rect x="6" y="6" width="12" height="12" rx="2.5" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  wifi: (
    <>
      <path d="M2.5 9.5C8 4.5 16 4.5 21.5 9.5M5.5 12.8c3.8-3.3 9.2-3.3 13 0M8.5 16c2-1.7 5-1.7 7 0" />
      <circle cx="12" cy="19" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  wifiOff: (
    <>
      <path d="M2.5 9.5c2.1-1.9 4.5-3.1 7-3.7M14.5 5.8c2.5.6 4.9 1.8 7 3.7M5.5 12.8c1.4-1.2 3-2 4.7-2.4M15.3 11.5c1.2.4 2.3 1 3.2 1.8M8.5 16c2-1.7 5-1.7 7 0" />
      <path d="M4 4l16 16" />
      <circle cx="12" cy="19" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  logout: (
    <>
      <path d="M10 4.5H6A1.5 1.5 0 0 0 4.5 6v12A1.5 1.5 0 0 0 6 19.5h4" />
      <path d="M14 8l4 4-4 4M18 12H9" />
    </>
  ),
  copy: (
    <>
      <rect x="8.5" y="8.5" width="11" height="11" rx="2.5" />
      <path d="M15.5 8.5V6A1.5 1.5 0 0 0 14 4.5H6A1.5 1.5 0 0 0 4.5 6v8A1.5 1.5 0 0 0 6 15.5h2.5" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4.5 4.5" />
    </>
  ),
  trash: (
    <>
      <path d="M4.5 6.5h15M9.5 6.5v-2h5v2M6.5 6.5l.8 12.2a1.5 1.5 0 0 0 1.5 1.3h6.4a1.5 1.5 0 0 0 1.5-1.3l.8-12.2" />
      <path d="M10 10v6M14 10v6" />
    </>
  ),
  fingerprint: (
    <>
      <path d="M2.8 11.6A9.2 9.2 0 0 1 12 2.6a9.2 9.2 0 0 1 7.3 3.6" />
      <path d="M5.2 19c.5-1.4 1-4.1 1-6.9 0-.7.1-1.3.3-1.9" />
      <path d="M9 6.9A6 6 0 0 1 18 12v2" />
      <path d="M12 10.2a1.9 1.9 0 0 0-1.9 1.9c0 1-.1 2.4-.2 3.8" />
      <path d="M14 13.1c0 2.3 0 6.1-1 8.5" />
      <path d="M8.7 21.4c.2-.6.4-1.2.5-1.9" />
      <path d="M17.3 20.4c.1-.6.4-2.1.5-2.8" />
      <path d="M21.4 15.4c.2-1.7.1-3.5 0-4.4" />
    </>
  ),
  face: (
    <>
      <path d="M3.5 8.5V6A2.5 2.5 0 0 1 6 3.5h2.5M15.5 3.5H18A2.5 2.5 0 0 1 20.5 6v2.5M20.5 15.5V18a2.5 2.5 0 0 1-2.5 2.5h-2.5M8.5 20.5H6A2.5 2.5 0 0 1 3.5 18v-2.5" />
      <path d="M9.5 10v1.5M14.5 10v1.5M9.5 15c1.5 1.2 3.5 1.2 5 0" />
    </>
  ),
  lock: (
    <>
      <rect x="4.5" y="10.5" width="15" height="10" rx="3" />
      <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5M12 14.5v2.5" />
    </>
  ),
  eye: (
    <>
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  eyeOff: (
    <>
      <path d="M3 3l18 18M10.6 5.1A10 10 0 0 1 12 5c6.4 0 10 7 10 7a17 17 0 0 1-3.2 4M6.6 6.6A17 17 0 0 0 2 12s3.6 7 10 7a10 10 0 0 0 4.2-.9M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </>
  ),
  key: (
    <>
      <circle cx="8" cy="14" r="4" />
      <path d="m11 11 8.5-8.5M16 6l2.5 2.5M13.5 8.5 16 11" />
    </>
  ),
  refresh: (
    <>
      <path d="M19.5 12a7.5 7.5 0 0 1-13 5.1M4.5 12a7.5 7.5 0 0 1 13-5.1" />
      <path d="M17.5 3.5v3.5H14M6.5 20.5V17H10" />
    </>
  ),
  download: (
    <>
      <path d="M12 4v11M7.5 10.5 12 15l4.5-4.5" />
      <path d="M4.5 17.5v1A1.5 1.5 0 0 0 6 20h12a1.5 1.5 0 0 0 1.5-1.5v-1" />
    </>
  ),
  inbox: (
    <>
      <path d="M4.5 13.5V6A1.5 1.5 0 0 1 6 4.5h12A1.5 1.5 0 0 1 19.5 6v7.5" />
      <path d="M4.5 13.5h4.2l1.2 2.5h4.2l1.2-2.5h4.2v4.5A1.5 1.5 0 0 1 18 19.5H6a1.5 1.5 0 0 1-1.5-1.5v-4.5Z" />
    </>
  ),
  layers: (
    <>
      <path d="m12 4 8.5 4.5L12 13 3.5 8.5 12 4Z" />
      <path d="m3.5 12.5 8.5 4.5 8.5-4.5M3.5 16.5 12 21l8.5-4.5" />
    </>
  ),
  x: <path d="M6 6l12 12M18 6 6 18" />,
  maximize: <rect x="5" y="5" width="14" height="14" rx="2" />,
  restore: <path d="M8 8V6a1.5 1.5 0 0 1 1.5-1.5h8A1.5 1.5 0 0 1 19 6v8a1.5 1.5 0 0 1-1.5 1.5H16M6.5 8.5h8A1.5 1.5 0 0 1 16 10v8a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 18v-8a1.5 1.5 0 0 1 1.5-1.5Z" />,
  fullscreen: <path d="M4.5 9V4.5H9M15 4.5h4.5V9M19.5 15v4.5H15M9 19.5H4.5V15" />,
  euro: (
    <>
      <path d="M17.5 6.5A7 7 0 0 0 7 12a7 7 0 0 0 10.5 5.5" />
      <path d="M4.5 10.5h9M4.5 13.5h9" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="4.5" width="17" height="16" rx="3.5" />
      <path d="M3.5 9.5h17M8 3v3M16 3v3" />
      <circle cx="12" cy="15" r="1.3" fill="currentColor" stroke="none" />
    </>
  ),
  edit: (
    <>
      <path d="M4.5 19.5h4l10-10-4-4-10 10v4Z" />
      <path d="m13 7 4 4" />
    </>
  ),
  shield: (
    <>
      <path d="M12 3.5 5 6.2v5.3c0 4.2 2.9 7.6 7 9 4.1-1.4 7-4.8 7-9V6.2L12 3.5Z" />
      <path d="m9 12 2 2 4-4.5" />
    </>
  ),
  server: (
    <>
      <rect x="3.5" y="4.5" width="17" height="6" rx="2" />
      <rect x="3.5" y="13.5" width="17" height="6" rx="2" />
      <circle cx="7.5" cy="7.5" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="7.5" cy="16.5" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  percent: (
    <>
      <path d="m6 18 12-12" />
      <circle cx="7.5" cy="7.5" r="2.2" />
      <circle cx="16.5" cy="16.5" r="2.2" />
    </>
  ),
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="3" />
      <path d="m4.5 8 7.5 5.5L19.5 8" />
    </>
  ),
  send: <path d="M20.5 4 3.5 11l6.5 2.5L12.5 20l8-16ZM10 13.5l4-4" />,
  reply: <path d="M10 6 4 12l6 6M4 12h9a7 7 0 0 1 7 7" />,
  forward: <path d="m14 6 6 6-6 6M20 12h-9a7 7 0 0 0-7 7" />,
  paperclip: <path d="m19 11-7.2 7.2a4.5 4.5 0 0 1-6.4-6.4l7.6-7.6a3 3 0 0 1 4.2 4.2l-7.5 7.5a1.5 1.5 0 0 1-2.1-2.1L15 8" />,
  star: <path d="m12 4 2.4 5 5.4.7-4 3.8 1 5.4L12 16.3 7.2 18.9l1-5.4-4-3.8L9.6 9 12 4Z" />,
};

export function Icon({
  name,
  size = 20,
  strokeWidth = 1.6,
  className,
  style,
}: {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
